import {Card, CardMedia, Grid, Link} from '@mui/material'
import 'react'

interface TrustBannerProps {
    bannerUrl: string,
    bannerImage: string,
    alt: string,
}
const onClickBanner = (bannerUrl: string) =>{
    window.open(bannerUrl)
}

const TrustBanner = (props: TrustBannerProps) => {
    const {bannerImage, alt, bannerUrl} = props

    let trustBannerUrl = bannerUrl

    // validate trust banner has https://
    if(bannerUrl && !bannerUrl.includes(`https://`)){
        trustBannerUrl = `https://${bannerUrl}`
    }

    // banner isn't clickable
    const bannerComponent = (<Card sx={{border: `none`, boxShadow: `none`}}>
        <CardMedia
            sx={{width: `100%`, objectFit: `contain`}}
            component="img"
            image={bannerImage}
            alt={alt}
        />
    </Card>)

    // banner is clickable
    const clickableBanner = (
        <Link onClick={() => onClickBanner(trustBannerUrl)}>
            {bannerComponent}
        </Link>
    )

    return (
        <Grid item m="auto" xs={10} md={10} hidden={!bannerImage}>
            <Grid xs={12} container justifyContent="center">
                {trustBannerUrl ? clickableBanner : bannerComponent}
            </Grid>
        </Grid>
    )
}

export default TrustBanner